import { useState, useEffect } from "react";
import axios from "axios";
import { useAuth } from "../../contexts/AuthContext";
import {
  Typography,
  List,
  ListItem,
  ListItemText,
  Divider,
  Card,
  CardContent,
  Chip,
  Stack,
} from "@mui/material";
import { head } from "lodash";

export default function CreatedDivesites() {
  const [publishedDivesites, setPublishedDivesites] = useState([]);
  const [unpublishedDivesites, setUnpublishedDivesites] = useState([]);
  const { userObjectId, currentUser } = useAuth();

  useEffect(() => {
    const fetchCreatedDivesites = async () => {
      if (userObjectId) {
        try {
          const token = await currentUser.getIdToken();

          const response = await axios.get(
            `/api/divesites/user/${userObjectId}`,
            {
              headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
              }
            }
          );
          const allDivesites = response.data;
          const published = allDivesites.filter(
            (divesite) => divesite.lifecycle.published
          );
          const unpublished = allDivesites.filter(
            (divesite) => !divesite.lifecycle.published
          );
          setPublishedDivesites(published);
          setUnpublishedDivesites(unpublished);
        } catch (error) {
          console.error("Error fetching created divesites:", error);
        }
      }
    };

    fetchCreatedDivesites();
  }, [userObjectId]);

  return (
    <Card sx={{ mb: 2 }}>
      <CardContent>
        <Typography
          variant="subtitle1"
          gutterBottom
          sx={{ fontWeight: "bold" }}
        >
          Divesites you created
        </Typography>
        <Stack direction="row" spacing={1} sx={{ mb: 1 }}>
          <Chip
            label={`Published: ${publishedDivesites.length}`}
            color="primary"
            size="small"
          />
          <Chip
            label={`Drafts: ${unpublishedDivesites.length}`}
            color="secondary"
            size="small"
          />
        </Stack>

        {publishedDivesites.length > 0 ? (
          <List disablePadding>
            {publishedDivesites.map((divesite, index) => (
              <div key={divesite._id}>
                <ListItem>
                  <ListItemText primary={divesite.uddf.divesite.site.name} />
                </ListItem>
                {index < publishedDivesites.length - 1 && <Divider />}
              </div>
            ))}
          </List>
        ) : unpublishedDivesites.length === 0 ? (
          <Typography color="textSecondary">
            No divesites created yet.
          </Typography>
        ) : null}

        {unpublishedDivesites.length > 0 && (
          <>
            <Typography
              variant="subtitle2"
              sx={{ mt: 2, color: "textSecondary" }}
            >
              Drafts
            </Typography>
            <List disablePadding>
              {unpublishedDivesites.map((divesite, index) => (
                <div key={divesite._id}>
                  <ListItem>
                    <ListItemText primary={divesite.uddf.divesite.site.name} />
                  </ListItem>
                  {index < unpublishedDivesites.length - 1 && <Divider />}
                </div>
              ))}
            </List>
          </>
        )}
      </CardContent>
    </Card>
  );
}
